import "./chat.css"
import { useState, useRef, useEffect } from 'react'
import { Group, Search, ArrowBack, CloseOutlined, AttachFile, SentimentSatisfiedAltOutlined } from '@material-ui/icons'
import { Avatar, Badge } from '@material-ui/core'
import userImage from 'assets/Images/icons/chatuser.png'
import myImg from 'assets/Images/icons/myImg.png'
import bigChatIcon from 'assets/Images/icons/bigChatIcon.svg'
import { withStyles } from '@material-ui/core/styles';
import { Link, useParams } from "react-router-dom";

//========================= THIS IS CHAT PAGE ==================================================
// Every thing is just static all states and data
const Chat = () => {
    // id of user
    let { id } = useParams();
    // 
    const inputRef = useRef(null)
    const messages = useRef(null)
    // 
    const bottomElement = useRef(null)
    // 
    const [chatSideBar, setChatSideBar] = useState(false);
    const [newMsg, setNewMSg] = useState('');
    const [searchOpened, setSearchOpened] = useState(false);
    const [formData, setFormData] = useState('');

    const [selectedChat, setSelectedChat] = useState({
        selected: false,
        id: null,
        userName: '',
        responseRate: '',
        online: '',
    });

    // chats data array
    const chatsData = [
        {
            id: 0,
            userName: 'Diago Mardz',
            responseRate: '1hr',
            online: true,
            conversations: [
                { msg: 'Hi please let me know when i can discuss with you', date: 'Jul 25, 1:19 PM', me: false },
                { msg: 'Yes please send me the location ', date: 'Jul 25, 1:20 PM', me: true },
                { msg: 'Hi please let me know when i can discuss with you', date: 'Jul 25, 1:21 PM', me: false },
                { msg: 'Hi please let me know when i can discuss with you', date: 'Jul 25, 1:19 PM', me: false },
                { msg: 'Yes please send me the location', date: 'Jul 25, 1:20 PM', me: true },
                { msg: 'Hi please let me know when i can discuss with you', date: 'Jul 25, 1:21 PM', me: false },
                { msg: 'Hi please let me know when i can discuss with you', date: 'Jul 25, 1:19 PM', me: false },
                { msg: 'Yes please send me the location', date: 'Jul 25, 1:20 PM', me: true },
                { msg: 'Hi please let me know when i can discuss with you', date: 'Jul 25, 1:21 PM', me: false },
            ]
        },
        {
            id: 1,
            userName: 'John Doe',
            online: false,

            responseRate: '1:30hr',
            conversations: [
                { msg: 'Hi please let me know when i can discuss with you', date: 'Jul 25, 1:19 PM', me: false },
                { msg: 'Yes please send me the location', date: 'Jul 25, 1:20 PM', me: true },
                { msg: 'Hi please let me know when i can discuss with you', date: 'Jul 25, 1:21 PM', me: false },
            ]
        },
        {
            id: 2,
            userName: 'Mikel Hussey',
            online: true,
            responseRate: '2hr',
            conversations: [
                { msg: 'Hi please let me know when i can discuss with you', date: 'Jul 25, 1:19 PM', me: false },
                { msg: 'Yes please send me the location', date: 'Jul 25, 1:20 PM', me: true },
                { msg: 'Hi please let me know when i can discuss with you', date: 'Jul 25, 1:21 PM', me: false },
            ]
        },
        {
            id: 3,
            userName: 'David Warner',
            online: false,
            responseRate: '0:30hr',
            conversations: [
                { msg: 'Hi please let me know when i can discuss with you', date: 'Jul 25, 1:19 PM', me: false },
                { msg: 'Yes please send me the location', date: 'Jul 25, 1:20 PM', me: true },
                { msg: 'Hi please let me know when i can discuss with you', date: 'Jul 25, 1:21 PM', me: false },
            ]
        },
        {
            id: 4,
            userName: 'Maxwell',
            online: false,
            responseRate: 'instant',
            conversations: [
                { msg: 'Hi please let me know when i can discuss with you', date: 'Jul 25, 1:19 PM', me: false },
                { msg: 'Yes please send me the location', date: 'Jul 25, 1:20 PM', me: true },
                { msg: 'Hi please let me know when i can discuss with you', date: 'Jul 25, 1:21 PM', me: false },
            ]
        },
        {
            id: 5,
            online: true,
            userName: 'Steve Smith',
            responseRate: '5hr',
            conversations: [
                { msg: 'Hi please let me know when i can discuss with you', date: 'Jul 25, 1:19 PM', me: false },
                { msg: 'Yes please send me the location', date: 'Jul 25, 1:20 PM', me: true },
                { msg: 'Hi please let me know when i can discuss with you', date: 'Jul 25, 1:21 PM', me: false },
            ]
        },
    ];

    //========================== go to top of the chat =====================
    // useEffect(() => {
    //     if (inputRef?.current) {
    //         inputRef.current.focus();
    //         setNewMSg('');
    //         if (bottomElement.current) {
    //             messages.current.scrollTop = messages.current.scrollHeight;
    //         }
    //     }
    // }, [selectedChat]);

    // check for chat user "" static ""   =============================
    useEffect(() => {
        let chats = chatsData;
        if (id !== null && id !== undefined) {
            if (inputRef?.current) {
                inputRef.current.focus();
                setNewMSg('');
                if (bottomElement.current) {
                    messages.current.scrollTop = messages.current.scrollHeight;
                }
            };
            setSelectedChat({
                selected: true,
                id: id,
                    userName: chats[id]?.userName,
                    responseRate: chats[id]?.responseRate,
                    online: chats[id]?.online,
                conversations: chats[id]?.conversations
            })
            setChatSideBar(false)
        } else {
            setNewMSg('');
            setSelectedChat({
                selected: false,
                id: null,
                    userName: '',
                    responseRate: '',
                    online: '',
                conversations: []
            })
            setChatSideBar(false)
        }
    }, [id]); // eslint-disable-next-line react-hooks/exhaustive-deps

    //================ send message "static" ================
    const sendMsg = (e) => {
        e.preventDefault();
        if (newMsg?.trim()?.length > 0) {
            setNewMSg('');
            if (bottomElement.current) {
                messages.current.scrollTop = messages.current.scrollHeight;
            }
        }
    };

    //======================= online badge ===============
    const StyledBadge = withStyles((theme) => ({
        badge: {
            backgroundColor: selectedChat?.online ? '#32E077' : '#474747ed',
            '&::after': {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                borderRadius: '50%',
                content: '""',
            },
        },
        '@keyframes ripple': {
            '0%': {
                transform: 'scale(.8)',
                opacity: 1,
            },
            '100%': {
                transform: 'scale(2.4)',
                opacity: 0,
            },
        },
    }))(Badge);

    // 
    return (
        <div className="chat-page">
            {chatSideBar && <div onClick={() => setChatSideBar(false)} className="chat-sidebar-backdrop"></div>}
            <div className="cs_container">
                <button className="open-chat-sidebar" onClick={() => setChatSideBar(true)}>
                    <Group />
                </button>
                <div className="row chat-main-row">
                    <div className={`${chatSideBar ? 'chat-sidebar-opened' : ''} col-md-4 p-0 all-contact-list-sidebar`}>
                        <div className="chat-all-contact-sec">
                            {/* <div className="chat-side-bar-top">
                                <button onClick={() => setChatSideBar(false)}>
                                    <ArrowBack />
                                </button>
                            </div> */}
                            <form className="search-chat-form d-flex justify-content-between align-items-center">
                                {searchOpened ?
                                    <>
                                        <div onClick={() => { setSearchOpened(false); setFormData('') }} className="back-search-contact-icon cursor-pointer p-1 rounded rounded-circle bg-white text-sec">
                                            <ArrowBack />
                                        </div>
                                        <input type="search" placeholder="Search here..." onChange={(e) => { setFormData(e.target.value) }} value={formData} />
                                    </>
                                    :
                                    <>
                                        <h4 className="px-2 chat-list-contact-head">Contacts</h4>
                                        <div onClick={() => setSearchOpened(true)} className="search-contact-cht-icon cursor-pointer p-1 rounded rounded-circle">
                                            <Search />
                                        </div>
                                    </>
                                }
                            </form>
                            <div className="all-chats-contact-list">
                                {chatsData.map((chat_data, ind) => (
                                    <Link to={`/inbox/${ind}`}
                                        // onClick={() => {
                                        //     setSelectedChat({ selected: true, ...chat_data });
                                        //     setChatSideBar(false)
                                        // }}
                                        key={ind}
                                        className={`side-contact-list-box d-flex p-2 justify-content-start align-items-start py-2  border-bottom w-100
                                        ${parseInt(id) === chat_data.id ? 'active-chat-box' : ''}
                                        `}>
                                        <div className="col-2 contact-list-avatar-wrapper p-0 text-center">
                                            <Avatar src={userImage} alt="user" />
                                        </div>
                                        <div className="col-10=">
                                            <p className="text-pr m-0 side-chat-prev-username">
                                                {chat_data?.userName}
                                            </p>
                                            <p className="text-gr side-chat-prev-text">
                                                {chat_data?.conversations[chat_data?.conversations.length - 1]?.msg} .
                                            </p>
                                            <span className="d-flex side-chat-prev-date w-100 justify-content-end align-items-center text-sec text-right p-0">
                                                {chat_data?.conversations[chat_data?.conversations.length - 1]?.date}
                                            </span>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8 p-0">
                        {selectedChat?.selected ?
                            <div className="main-chat-inbox-screen d-flex flex-column">
                                <header className="inbox-header d-flex justify-content-between align-items-center px-3 py-2">
                                    <div className="inbox-other-user-info d-flex flex-wrap justify-content-start align-items-center text-white">
                                        <StyledBadge
                                            variant="dot"
                                            overlap="circular"
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'right',
                                            }}
                                        >
                                            <Avatar src={userImage} alt="user" />
                                        </StyledBadge>
                                        <span className="mx-2 my-md-0 my-4 fw-bold">{selectedChat?.userName} .</span>
                                        <span className="mx-3 "> Usual response rate {selectedChat?.responseRate}</span>
                                    </div>
                                    <div onClick={() => {
                                        setSelectedChat({ selected: false, userName: '' })
                                    }} className="close-inbox-shat-icon d-flex justify-content-between align-items-center text-white cursor-pointer rounded rounded-circle border">
                                        <CloseOutlined className="close-cht-btn" />
                                    </div>
                                </header>
                                <div ref={messages} className="chat-screen-inner">
                                    {selectedChat?.conversations?.map((his_chats, index) => {
                                        return (
                                            <li key={index} className={`msg-box-conv ${his_chats?.me ? 'me_msg' : 'others_msg'} d-flex justify-content-start align-items-start`}>
                                                <div className="other-msg-left">
                                                    <Avatar src={his_chats?.me ? myImg : userImage} alt={his_chats?.userName} />
                                                </div>
                                                <div className="other-msg-right">
                                                    <p className={`${his_chats?.me ? 'text-right' : ''} msg-name `}>{his_chats.me ? 'Me' : selectedChat?.userName}</p>
                                                    <div className="other-msg-right_box">
                                                        <p className="main-msg-text">
                                                            {his_chats?.msg}

                                                        </p>
                                                        <span className={`${his_chats?.me ? 'text-right' : ''} main-msg-send-date text-gr`}>
                                                            {his_chats?.date}
                                                        </span>
                                                    </div>
                                                </div>
                                            </li>
                                        )
                                    })}
                                    <div ref={bottomElement} className="botm-element"></div>
                                </div>
                                <form onSubmit={sendMsg} className="inbox-footer d-flex justify-content-between align-items-center">
                                    <div className="send-msg-form d-flex justify-content-between align-items-center">
                                        <input ref={inputRef} type="text" placeholder="Type a message" onChange={(e) => setNewMSg(e.target.value)} value={newMsg} />
                                        <div className="send-msg-exrta-msg">
                                            <button className="attach-files-and-emoji text-gr">
                                                <SentimentSatisfiedAltOutlined />
                                            </button>
                                            <button className="attach-files-and-emoji text-gr">
                                                <AttachFile />
                                            </button>
                                        </div>
                                    </div>
                                    <div className="send-chat-btn">
                                        <button type="submit">Send</button>
                                    </div>
                                </form>
                            </div>
                            :
                            <div className="d-flex main-chat-inbox-screen py-3 px-2 text-center flex-column justify-content-center align-items-center text-gr">
                                <img className="not-selected-cht-img" src={bigChatIcon} alt="" />
                                <h3>Select a Conversation</h3>
                                <p className="pt-2">Try selecting a conversation</p>
                                <p>or searching for someone specific.</p>
                            </div>}
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Chat;
